import { Button, ButtonProps } from '../shadcn'
import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'
import { forwardRef } from 'react'

export const AsyncButton = forwardRef<HTMLButtonElement, ButtonProps & { loading?: boolean }>(
  ({ children, loading, disabled, ...props }, ref) => {
    return (
      <Button ref={ref} disabled={disabled || loading} {...props}>
        <span className="relative inline-flex items-center justify-center">
          {loading && <Loader2 className="absolute inset-0 m-auto h-4 w-4 animate-spin z-10" />}
          <div className={cn('flex min-w-0 items-center gap-2', { invisible: loading })}>{children}</div>
        </span>
      </Button>
    )
  }
)

AsyncButton.displayName = 'AsyncButton'
